import axios from "axios";

const API_BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";

class RequestsService {
  /**
   * Получение входящих запросов на чат
   * @param {string} userId — ID текущего пользователя (кому пришли запросы)
   * @returns {Promise<Array>} — Массив запросов с вложенными пользователями
   */
  static async getMyRequests(userId) {
    try {
      if (!userId) throw new Error("userId обязателен");

      const response = await axios.get(`${API_BASE_URL}/get_my_requests`, {
        params: { user_id: userId },
        headers: {
          "Content-Type": "application/json"
        }
      });

      console.log("✅ Запросы успешно получены:", response.data.requests);
      return response.data.requests || [];
    } catch (error) {
      console.error("❌ Ошибка получения запросов:", error);
      return [];
    }
  }

  /**
   * Принятие запроса — создаёт чат с первым сообщением из comment
   * @param {string} ownerId — текущий пользователь (принимающий)
   * @param {string} requesterId — кто отправил запрос
   * @param {string} comment — текст первого сообщения
   */
static async acceptRequest(ownerId, requesterId, comment, requestId) {
  try {
    const payload = {
      user_id: ownerId,
      interlocutor_id: requesterId,
      comment: comment,
      request_id: requestId // ← добавили сюда!
    };

    console.log("📤 Отправляем accept_chat_request:", payload);

    const response = await axios.post(`${API_BASE_URL}/accept_chat_request`, payload, {
      headers: {
        "Content-Type": "application/json"
      }
    });

    console.log("✅ Чат успешно создан:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Ошибка при создании чата:", error.response?.data || error.message);
    throw error;
  }
}

  /**
   * Удаление запроса по его request_id
   * @param {string} requestId — ID запроса
   */
  static async deleteRequest(requestId) {
    try {
      const response = await axios.post(`${API_BASE_URL}/delete_chat_request`, {
        request_id: requestId
      });

      console.log("🗑️ Запрос удалён:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при удалении запроса:", error);
      throw error;
    }
  }
}

export default RequestsService;